import React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import { ThemeProvider, useTheme } from "@mui/material/styles";

const Loading = () => {
  const theme = useTheme();

  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ height: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <CircularProgress />
      </Box>
    </ThemeProvider>
  );
};

export default Loading;
